Syncs a position.
